module.exports = __webpack_public_path__ + "img/cutomers.ed17f955.svg";